import { ReactComponentElement, useEffect, useRef, useState } from "react";
import {useT} from "../../../../../../helpers/i18n";
import { useDispatch, useSelector } from "react-redux";
import BedroomCard from "./BedroomCard";
import Checkers from "../../../../../../helpers/class/Checkers";
import { SwiperSlide } from "swiper/react";
import SwipperWrapper from "../../../../properties/partials/SwipperWrapper";
import { AnyComponent } from "styled-components/native/dist/types";
import { fetchBedroomPricesAction, setDateRange, setSearchSpinner } from "../../../../../../redux/actions";
import { getPropertyBookingBedrooms } from "../../../../../../api/client";
import UnderSliderContainedBar from "../../../../index/bookingSearchBar/UnderSliderContainedBar";
import SliderContainedBar from "../../../../index/bookingSearchBar/SliderContainedBar";
import BookingSearchBar from "../../../../index/BookingSearchBar";
import RightModal from "../../../../properties/partials/RightModal";
import ContentWrapper from "../../../../properties/partials/ContentWrapper";
import BedroomsContentWrapper from "../../../../properties/partials/BedroomsContentWrapper";
import BookingBedroomButtons from "./BookingBedroomButtons";
import SinglePropertyData from "./ChainPropertyData";
import Skeleton from "react-loading-skeleton";
import BedroomData from "./BedroomData";
import {fetchBuilderSettingByKey} from "../../../../../../helpers/MethodHelper";

export default function BedroomsView(props) {

  const t = useT()

  const dispatch = useDispatch()

  const sectionBackgroundColor = useSelector(
    state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_homepage_featured_properties_section_color')
  );

  const [bookingBedrooms, setBookingBedrooms] = useState(null);

  const checkin = useSelector(state => state['propertiesParams']['checkin'])

  const bedroomPricing = useSelector(state => state['appSettings']['bedroomPricing'])

  const triggerSearh = useSelector(state => state['appSettings']['searchTrigger'])

  const checkout = useSelector(state => state['propertiesParams']['checkout'])

  const pageId = useSelector(state => state['propertiesParams']['page_id'])

  const adults = useSelector(state => state['propertiesParams']['adults'])

  const kids = useSelector(state => state['propertiesParams']['kids'] + state['propertiesParams']['infants'])

  const propertyId = useSelector(state => state['propertiesParams']['property_id']);

  useEffect(() => {
    let cancelled = false;

    setBookingBedrooms(null);

    getPropertyBookingBedrooms(propertyId, 'is_booking=1&exclude_parking=1').then((data : any) => {
      if (cancelled) return;
      const bedrooms = Checkers.isValidArray(data?.bedrooms) ? data.bedrooms : [];
      setBookingBedrooms(bedrooms.filter((bedroom) =>
        Checkers.isValidArray(bedroom.media) && bedroom.media.some((m) => Checkers.isValidString(m?.image))
      ));
      dispatch({type: "updateBookingBedrooms", data: bedrooms});
    }).catch(() => {
      if (!cancelled) setBookingBedrooms([]);
    });

    return () => { cancelled = true; };
  }, [propertyId])

  useEffect(() => {
    const fetchData = async () => {
      await dispatch<any>(fetchBedroomPricesAction(pageId, propertyId, checkin, checkout, adults, kids));
      dispatch(setSearchSpinner(false));
    };
    fetchData();
  }, [triggerSearh]);

  const hasSectionBackground = Checkers.isHexColor(sectionBackgroundColor);

  const centerTwoItems = Checkers.isValidArray(bookingBedrooms) && bookingBedrooms.length === 2;

  if (bookingBedrooms != null && bookingBedrooms.length === 0) {
    return null;
  }

  if (Checkers.valueToBoolean(props.isManager)) {
    return (
      <>
        {bookingBedrooms && Checkers.isValidArray(bookingBedrooms) ? (
          <>
            <p className="block-title m-t-40 hint-text no-margin justify-content-left text-left d-block ">
              {t('property.roomTypesIntro')}
            </p>
            <h2 className="pb-4 mt-1 fw-normal">{t('property.roomTypes')}</h2>

            <div className="SearchBar-Form__column row justify-content-end bg-white no-margin p-2 w-100 d-flex border-radius-10 shadow position-relative">
              <BookingSearchBar
                containerClass={"container-fluid"}
                padding={10}
                isManager={true}
                noShadow={true}
                sliderSearchBar={true}
                sliderSearchBarFullWidth={false}
                bookingSearchbarWithBedrooms={props.bookingBedrooms}
                isHomePage={false}
                isHotel={props.isHotel ? props.isHotel : false}
              />
            </div>
          </>) : (
          <div>
            <Skeleton height={75} className="col-12 b-rad-lg d-block" />
          </div>
        )}
        <div className="pt-10 mt-4">
          <div className="row">
            {bookingBedrooms && Checkers.isValidArray(bookingBedrooms) ? (
              bookingBedrooms.map((bedroom, key) => (
                <div className="col-4 col-md-4" key={key}>
                  <BedroomData bedroom={bedroom} prices={bedroomPricing} />
                </div>
              ))
            ) : (
              <>
                <div>
                  <Skeleton height={340} className="col-12 b-rad-lg d-block" />
                  <Skeleton height={27} className="col-12 b-rad-lg d-block" />
                  <Skeleton height={27} className="col-12 b-rad-lg d-block" />
                </div>
              </>
            )}
          </div>
        </div>
      </>
    );
  }

  return (
    <div
      className={
        "properties-related p-t-50 p-b-50"
        + (hasSectionBackground ? ' has-section-background' : '')
        + (centerTwoItems ? ' center-two-items' : '')
      }
      style={hasSectionBackground ? {
        background: sectionBackgroundColor,
        boxShadow: `0 0 0 100vmax ${sectionBackgroundColor}`,
        clipPath: 'inset(0 -100vmax)',
      } : {}}
    >
      <div className={props.isHotel ? '' : 'container'}>
        {bookingBedrooms && Checkers.isValidArray(bookingBedrooms) ? (
          <>
            <p className={"block-title m-t-40 hint-text no-margin d-block" + (centerTwoItems ? ' text-center' : ' justify-content-left text-left') + (hasSectionBackground ? ' text-light-color' : '')}>
              {t('property.roomTypesIntro')}
            </p>
            <h2 className={"pb-4 mt-1 fw-normal" + (centerTwoItems ? ' text-center' : '') + (hasSectionBackground ? ' text-light-color' : '')}>{t('property.roomTypes')}</h2>
          </>) : (
          <div>
            <Skeleton height={75} className="col-12 b-rad-lg d-block" />
          </div>
        )}
        <div className="pt-10 mt-4">
          {bookingBedrooms && Checkers.isValidArray(bookingBedrooms) ? (
            bookingBedrooms.length > 3 ? (
              <SwipperWrapper
                key={"room-types-swiper"}
                imageSlider={false}
                htmlSlides={bookingBedrooms.map((bedroom, key) => (
                  <SwiperSlide key={key}>
                    <BedroomData bedroom={bedroom} prices={bedroomPricing} hideBookingActions={true} locationLabel={props.locationLabel} />
                  </SwiperSlide>
                ))}
                paginationBulletsEnabled={false}
                slidesPerView={3}
                slidesPerViewLg={3}
                slidesPerViewMd={3}
                slidesPerViewSm={2}
                slidesPerViewXs={1}
                spaceBetween={20}
                enableLoop={false}
                galleryHeight={'auto'}
                wrapperClassName={'d-navigation p-0'}
                enableFancyBox={false}
                centeredSlides={false}
              />
            ) : (
              <div className="row">
                {bookingBedrooms.map((bedroom, key) => (
                  <div className="col-12 col-md-4" key={key}>
                    <BedroomData bedroom={bedroom} prices={bedroomPricing} hideBookingActions={true} locationLabel={props.locationLabel} />
                  </div>
                ))}
              </div>
            )
          ) : (
            <div className="row">
              <div>
                <Skeleton height={340} className="col-12 b-rad-lg d-block" />
                <Skeleton height={27} className="col-12 b-rad-lg d-block" />
                <Skeleton height={27} className="col-12 b-rad-lg d-block" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
